import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/Login.vue";
import Dashboard from "@/components/Dashboard.vue";
import About from "@/views/About.vue";

const Users = () => import("@/views/Users/User.vue");
const Roles = () => import("@/views/roles/roles.vue");
const Permisos = () => import("@/views/permisos/permisos.vue");

const Log = () => import("@/views/logs/log.vue");

const Initial = () => import("@/views/Initial.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const Publicar = () => import("@/views/Publicar.vue");
const Publicar2 = () => import("@/views/Publicar2.vue");
const Reporte = () => import("@/views/Reporte.vue");
const GraficaReportePonencia = () => import("@/views/GraficaReportePonencia.vue");
const ReportePonencia = () => import("@/views/ReportePonencia.vue");
const GetFile = () => import("@/views/GetFile.vue");
const NotFound = () => import("@/views/NotFound.vue");
const Estadisticas = () => import("@/views/Estadisticas.vue");
const InteresSuperior = () => import("@/views/InteresSuperior.vue");
const EstadisticaReporte = () => import("@/views/EstadisticaReporte.vue");
const Delitos = () => import("@/views/Delitos.vue");
const TipoJuicio = () => import("@/views/TipoJuicios.vue");
const Sentidos = () => import("@/views/Sentidos.vue");
const CambiosMagistrado = () => import("@/views/CambiosMagistrado.vue");
const Ubicacion = () => import("@/views/Ubicacion.vue");
const Analisis = () => import("@/views/Analisis.vue");
const magistrados = () => import("@/views/magistrados/Magistrados.vue");
const GenerarJSON = () => import("@/views/GenerarJSON.vue");
const ResumenJobs = () => import("@/views/ResumenJobs.vue");
const TocasSinResumen = () => import("@/views/TocasSinResumen.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Initial",
    component: Initial,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/sentencias",
    name: "Publicar2",
    component: Publicar2,
  },
  {
    path: "/sentencias2",
    name: "Publicar",
    component: Publicar,
  },
  {
    path: "/reporte",
    name: "Reporte",
    component: Reporte,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/analisis",
    name: "GraficaReportePonencia",
    component: GraficaReportePonencia,
    // meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/reporte-por-ponencia",
    name: "ReportePonencia",
    component: ReportePonencia,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/permisos",
    name: "Permisos",
    component: Permisos,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/updatepassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: ['superadmin', 'admin', 'enlace'] }
  },
  {
    path: "/getfile/:id",
    name: "GetFile",
    component: GetFile,
    props: true,
  },
  {
    path :'*',
    component:NotFound
  },
  {
    path: "/estadisticas",
    name: "Estadisticas",
    component: Estadisticas,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/interes_superior",
    name: "InteresSuperior",
    component: InteresSuperior,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/estadistica_reporte",
    name: "EstadisticaReporte",
    component: EstadisticaReporte,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/delitos",
    name: "Delitos",
    component: Delitos,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/tipo-juicios",
    name: "TipoJuicio",
    component: TipoJuicio,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/sentidos",
    name: "Sentido",
    component: Sentidos,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/cambios-magistrado",
    name: "CambiosMagistrado",
    component: CambiosMagistrado,
    meta: { authorize: ['superadmin', 'admin'] }
  },
  {
    path: "/magistrados",
    name: "magistrados",
    component: magistrados,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/prueba-ubicacion",
    name: "Ubicacion",
    component: Ubicacion,
    // meta: { authorize: ['superadmin'] }
  },
  {
    path: "/analisis-2",
    name: "Analisis",
    component: Analisis,
  },
  {
    path: "/generar-json",
    name: "GenerarJSON",
    component: GenerarJSON,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/resumen-jobs",
    name: "ResumenJobs",
    component: ResumenJobs,
    meta: { authorize: ['superadmin'] }
  },
  {
    path: "/tocas-sin-resumen",
    name: "TocasSinResumen",
    component: TocasSinResumen,
    meta: { authorize: ['superadmin'] }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  const userLogged = JSON.parse(localStorage.getItem("user"));

  if (authorize) {
    //si si tiene restricciones la ruta
    if (!userLogged) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(userLogged.roles[0].name)) {
      return next({ path: "/" });
    }
  }
  if ( (to.path === "/login") && userLogged ) {
    return next({ path: "/sentencias" });
  }
  next();
});

export default router;
